import { render } from "./DialogFooter.vue?vue&type=template&id=45ed6bf8&ts=true"
import script from "./DialogFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogFooter.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/dialog/DialogFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45ed6bf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45ed6bf8', __exports__)) {
    api.reload('45ed6bf8', __exports__)
  }
  
  module.hot.accept("./DialogFooter.vue?vue&type=template&id=45ed6bf8&ts=true", () => {
    api.rerender('45ed6bf8', render)
  })

}


export default __exports__